import React from "react";
import { Button, Col, Row, Space } from "antd";

export default function FormTemplates(props: any) {
  const { closeModal = () => {} } = props;

  const handleDownload = (excelFilePath: string, outputName: string) => {
    // Tạo một thẻ <a> và thiết lập thuộc tính href và download
    const downloadLink = document.createElement("a");
    downloadLink.href = excelFilePath.toString();
    downloadLink.download = outputName;

    // Thêm thẻ vào DOM và kích hoạt sự kiện click
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Xóa thẻ <a> khỏi DOM sau khi tải xong
    document.body.removeChild(downloadLink);
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col>
          <Button
            onClick={() =>
              handleDownload(
                "/files/BcTinhHinhSdLaoDong.xlsx",
                "Báo cáo tình hình sử dụng lao động.xlsx"
              )
            }
          >
            BC Tình hình sử dụng lao động
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() =>
              handleDownload(
                "/files/DsDangKyHanhNghe.xlsx",
                "Danh sách đăng ký hành nghề.xlsx"
              )
            }
          >
            Danh sách đăng ký hành nghề
          </Button>
        </Col>
      </Row>

      <Row justify="end" style={{ marginTop: 12 }}>
        <Col>
          <Space>
            <Button
              onClick={closeModal}
              style={{
                backgroundColor: "red",
                borderColor: "red",
                color: "white",
              }}
            >
              Đóng
            </Button>
          </Space>{" "}
        </Col>
      </Row>
    </div>
  );
}
